import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        position: 'absolute',
        backgroundColor: props.colors.transparentPrimary,
        justifyContent: 'center',
        alignItems: 'center',
      },
      spinner: {
        width: 80,
        height: 80,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
      [maxSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)]: {},
    },
  )();
